module.exports = __webpack_public_path__ + "static/media/download.a7446fa0.svg";